// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"323":"c60a3d42","954":"b7e3fc4e"}[chunkId] + ".chunk.css";
};